import React from 'react';
import PropTypes from 'prop-types';

import Label from '../../components/Label';

const TextInput = (props) => {
  const { id, label, value, onChange, disabled, errors } = props;
  return (
    <div className="input">
      <Label name={id} title={label} errors={errors} />
      <input
        id={id}
        type="text"
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default TextInput;

TextInput.propTyptes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}),
};

TextInput.defaultProps = {
  disabled: false,
  errors: {},
};
